import type { HapticsPort } from "../../ports/haptics.port";

// navigator.vibrate как haptic feedback. На desktop / iOS Safari — noop.
const IMPACT_DURATIONS: Record<"light" | "medium" | "heavy", number> = {
	light: 10,
	medium: 20,
	heavy: 35,
};

const NOTIFICATION_PATTERNS: Record<"success" | "warning" | "error", number[]> = {
	success: [12, 30, 12],
	warning: [20, 60, 20, 60, 20],
	error: [40, 80, 40, 80, 40],
};

function vibrate(pattern: number | number[]): void {
	if (typeof navigator === "undefined") return;
	const v = (
		navigator as Navigator & {
			vibrate?: (p: number | Iterable<number>) => boolean;
		}
	).vibrate;
	if (typeof v !== "function") return;
	if (typeof pattern === "number") v.call(navigator, pattern);
	else v.call(navigator, pattern);
}

export const hapticsWebAdapter: HapticsPort = {
	async impact({ style }) {
		vibrate(IMPACT_DURATIONS[style]);
	},
	async selection() {
		vibrate(8);
	},
	async notification({ type }) {
		vibrate(NOTIFICATION_PATTERNS[type]);
	},
};
